import React, { useState , useEffect} from 'react';

import './calendarStyles.css'

const CalendarComponent = ({day,milestoneDays, hasFailed, failDay, isForEdit, setFailedDate}) => {
  // Example selected dates for demonstration purposes
 const [dayToImage, setDayToImage] = useState({
    "1":"/images/reznik.png",
    "6":"/images/cheney.png",
    "13":"/images/manson.png",
    "20":"/images/patrick.png",
    "27":"/images/batman.png",
    "31": "/images/special.png"
 })
 const [selectedDate, setSelectedDate] = useState(1)
  // Function to handle date selection
  const handleDateClick = (date) => {
    // Add your logic to handle date selection here
    if (date <= day && date > 0){
        setSelectedDate(date)
        setFailedDate(date)

    }
  };

  // Generate days of November
  const daysInNovember = Array.from({ length: 31+2 }, (_, index) => index -1);

  

  const styles = {
    "preStart":{
        backgroundColor:"white",
        color:"white"
    },
    "currentDay":{
        width:"100%",
        backgroundSize:"cover",
    },
    "successfullDay":{
        backgroundColor:"rgba(0, 166, 64, 0.488)",
        opacity:0.9
    },
    "remainingDay":{
        backgroundColor:"rgba(0,0,0,0.2)",
        opacity:0.5
    },
    "unlockedCharacter":{
        width:"100%",
        
        backgroundImage:'url(/images/cheney.png)',
        backgroundSize:"cover",
        border: "None"
    },
    "lockedCharacter":{
        width:"100%",
        
        backgroundImage:'url(https://m.media-amazon.com/images/M/MV5BMTI1MTI5MjUyMV5BMl5BanBnXkFtZTYwMzY2Nzk2._V1_.jpg)',
        backgroundSize:"cover",
        border: "5% solid #00ff6a",
        filter:"grayscale(100%)"

    }
  }

  useEffect(()=>{
    
    setSelectedDate(day)
  },[])

  return (
    <div className="calendar">
      {daysInNovember.map((date) => {
        // <div
        //   key={date}
        //   className={`calendar-day ${selectedDates.includes(date) ? 'selected' : ''}`}
        //   onClick={() => handleDateClick(date)}
        // >
        var style={}
        var classname = "calendar-day "
        var dateText = date
        var selectedClassName = ""
        if (date <1){
            style = styles['preStart']
        }
        else if (date < day){
            if (hasFailed ){
                if(date < failDay){
                    style=styles['successfullDay']
                }
            }else{
                style=styles['successfullDay']
            }
        }
        else if(date == day){
            style=styles['currentDay']
            selectedClassName=" selected-default"
        }else{
            style=styles['remainingDay']
        }
        // color milestone dat
        if (milestoneDays.includes(date)){
            dateText = ""
            if (date <= day){
                style = {...styles['unlockedCharacter']}
            }else{
                style = {...styles['lockedCharacter']}
            }
            style.backgroundImage = `url(${dayToImage[""+date]})`
        }
        var new_style={}
        if (date == selectedDate){
            // selectedClassName = " selected-cursor"
            new_style.backgroundColor = "#ff7700"
            new_style.color = "white"
            new_style.border = "5px solid #ff7700fd"
            new_style.borderRadius=0
        }
        if (isForEdit){
        style= {...style, ...new_style}
        
        }
        classname += selectedClassName

        return <div key={date} className={classname } style={style
            } onClick={()=>handleDateClick(date)}>
          <div style={{marginTop:"100%", fontSize:"300%"}}>{dateText}</div>
        </div>
}
      
      )}
    </div>
  );
};

export default CalendarComponent;
